import CompanyInfo from './CompanyInfo';

export default CompanyInfo;
